import gql from 'graphql-tag'

export const GET_MATERIALS_BY_LPIDS = gql`
  query GetMaterialsByLpids($lpids: String!, $username: String!) {
    getMaterialsByLpids(lpids: $lpids, username: $username) {
      lpid
      shortname
      product
      status
      numberofunits
      completedunits
      details {
        lpid
        shortname
        fullname { 
          language
          fullname 
        }
        material_type
        description { 
          language
          description 
        }
        image
        level
        language
        attachments { 
          type
          url 
        }
        units {
          unitid
          shortname
          fullname
          order
          module
          image
          synchronous
          vocabexpressions
          grammaritem
          opcompletion
          opscore
          unitstatus
          lessonstatus
          flexstatus
          resetcount
          topic
          objectives
          isunit0
          unitsperchapter
          unittype
          ispilot
          packages {
            id
            name
            description
            url
            status
            lang
            redo
            published
          }
          activities { 
            type
            url
            actionplanurl
            reseturl
            activePage
            language { 
              code
              name
            }
          }
          attachments { 
            type
            url 
          }
          rounds { 
            name
            status
            order
            url
          }
          reseturl
          dependencies
          latestattemptdate
          ai_tutor_link { 
            target_lang
            ui_lang
            url
          }
        }
        numberofunits
        ai_tip_field
        tag_name
      }
    }
  }
`
